import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import SearchIcon from "@material-ui/icons/Search";
import api from "../../../services/axios";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
      justifyContent: "center",
    },
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  button: {
    marginLeft: theme.spacing(4),
  },
}));
export default function AlertDialog({ close, wallet, update }) {
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState([]);
  const [users, setUsers] = React.useState([]);
  const [usersfilter, setUsersfilter] = React.useState([]);
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const classes = useStyles();
  const getUsers = async () => {
    api
      .get("users", {
        headers: {
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((res) => {
        if (wallet.users_has_wallets.length) {
          wallet.users_has_wallets.map((user) => {
            if (res.data.length) {
              const index = res.data.findIndex(
                (users) => users.idusers === user.iduser
              );
              if (index !== -1) {
                res.data.splice(index, 1);
              }
            }
          });
        }
        setUsers(res.data);
        setUsersfilter(res.data);
      });
  };
  const searchingFor = (term) => (x) =>
    x.username.toLowerCase().includes(term.toLowerCase()) || !term;
  const onChange = (ev) => {
    const array = users;
    setUsersfilter(array.filter(searchingFor(ev.currentTarget.value)));
  };
  const confirm = () => {
    if (checked.length) {
      const data = {
        idwallets: wallet.idwallets,
        users: [...checked],
      };
      api
        .post("/wallet/addusers", data, {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        })
        .then((response) => {
          update();
          close();
        });
    }
    console.log(checked);
  };

  React.useEffect(() => {
    getUsers();
  }, []);
  return (
    <div>
      <Dialog
        open
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("WT.dialogs.user.title")}
        </DialogTitle>
        <DialogContent>
          <FormControl className={classes.margin}>
            <Input
              id="input-with-icon-adornment"
              onChange={onChange}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </FormControl>
          <List className={classes.root}>
            {!!usersfilter.length &&
              usersfilter.map((value, index) => {
                const labelId = `checkbox-list-label-${index}`;

                return (
                  <ListItem
                    key={value.idusers}
                    role={undefined}
                    dense
                    button
                    onClick={handleToggle(value.idusers)}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(value.idusers) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={`${value.username}`} />
                  </ListItem>
                );
              })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={close} autoFocus>
            <Button variant="contained" color="secondary">
              {t("WT.dialogs.user.bt2")}
            </Button>
          </Button>
          <Button color="primary" onClick={confirm} autoFocus>
            <Button
              variant="contained"
              style={{ background: "#34b7f1", color: "white" }}
            >
              {t("WT.dialogs.user.bt1")}
            </Button>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
